module.exports = __webpack_public_path__ + "static/media/speaking_crow3.37c5f62a.gif";